export default {
  activateLandingPageTitle: 'Události',
  activateProductCardTitle: 'Události',
  activateProductPageTitle: 'Rezervovat události',
  allProductsLandingPageTitle: 'Rezervujte si jedinečné zážitky',
  apply: 'Použít',
  buyTickets: 'Koupit vstupenky',
  cancel: 'Zrušit',
  clear: 'Vymazat',
  clearFilters: 'Vymazat filtry',
  discoverExperiences: 'Objevte zážitky',
  exclusive: 'Exkluzivní',
  experience: 'zážitek',
  experiencePhotoOfListing:
    'Fotografie zážitku {{photoNumber}} v nabídce {{listingTitle}}',
  experiences: 'zážitky',
  filterExperiences: 'Filtrovat zážitky',
  fromListingCard: 'Od',
  hostedBy: 'Pořádá',
  hostLandingPageTitle: 'Místní zážitky',
  hostProductCardTitle: 'Místní zážitky',
  hostProductPageTitle: 'Rezervovat místní zážitky',
  landingPageTitle: 'Rezervujte si jedinečné zážitky',
  mainLandingPageTitle: 'Všechny zážitky',
  more: 'Více',
  noExperiencesFound: 'Žádné zážitky nenalezeny',
  noExperiencesFoundFor: 'Žádné zážitky nenalezeny pro',
  experiencesFoundCount: 'Nalezeno {{count}} zážitků',
  profileImageOfHost: 'Profilový obrázek hostitele {{hostName}}',
  reserve: 'Rezervovat',
  reserveLandingPageTitle: 'Aktivity a vybavení',
  reserveProductCardTitle: 'Aktivity',
  reserveProductPageTitle: 'Rezervovat aktivity a vybavení',
  resultsPageTitle: 'Rezervujte si zážitky a aktivity',
};
